import { LOAD_PRODUCTS, PRODUCTS_LOADED, RESET_PRODUCTS, SYNC_FAILED } from './actionTypes';
import type { IEnvCropsProductsState } from './types';

export const initialState: IEnvCropsProductsState = {
  error: null,
  products: [],
  loading: false,
  loaded: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, error: null, loading: true };
    case PRODUCTS_LOADED:
      return {
        ...state,
        error: null,
        products: action.payload.data,
        loading: false,
        loaded: true,
      };

    case RESET_PRODUCTS:
      return { ...initialState };
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
